const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "goodsSkuCategory":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "goodsSkuCategory",
    reducer: reducer,
};

export default data;